/**
 * B517 — which chrome a storefront face wears, by where it lives (Pathik
 * 2026-09-22: "the widget once embedded on the site should work and look
 * like its part of the site"; "we also have this cart button but the flow
 * on navy pier does not allow add to cart. it right away places order").
 *
 *  - hosted: the whole storefront — its head, hero and cart door.
 *  - embedded, any presentation: NO cart door. An embed is one purchase,
 *    placed at once; a chip counting a cart that never fills is a lie.
 *  - embedded `list`: the product cards ONLY — the host page owns its own
 *    heading and navigation, so ours would be a second site inside theirs;
 *    a card press asks the host to open the booking dialog.
 *  - embedded `dialog` (B523, the ESB shape): the booking walks in place
 *    wearing the SHEET chrome — DialogShell's header (title, trail, ✕),
 *    hold strip and foot, all drawn by the storefront so they ride the
 *    tenant theme. No site head, no hero, and no floating close door:
 *    the shell's ✕ replaced B517's corner button.
 *  - the SITE FOOT ("<tenant> · Secure checkout · Powered by transact",
 *    75:2) belongs to a PAGE — the hosted storefront and the inline embed
 *    that wears its head. The list has no page of ours under it, and the
 *    dialog's frames (370-2 / 431-344) end at the sticky foot: the trust
 *    line there rides the PAY step's bar (356:85). Pathik 2026-09-28 on
 *    the Navy Pier cart: "powered by is all weird floating randomly in
 *    middle of the page" — it was this foot, rendered under a sheet that
 *    never asked for it.
 */
import type { Distribution, Presentation } from "./context.js";

export interface EmbedChrome {
  readonly head: boolean;
  readonly hero: boolean;
  readonly cartChip: boolean;
  readonly closeDoor: boolean;
  readonly pressOpensDialog: boolean;
  /** B523 — the DialogShell chrome (header + trail + hold strip + foot). */
  readonly sheet: boolean;
  /** The page foot under everything (75:2) — pages only, never a sheet or a bare list. */
  readonly siteFoot: boolean;
}

export function embedChrome(distribution: Distribution, presentation: Presentation | undefined): EmbedChrome {
  if (distribution === "hosted") return { head: true, hero: true, cartChip: true, closeDoor: false, pressOpensDialog: false, sheet: false, siteFoot: true };
  if (presentation === "list") return { head: false, hero: false, cartChip: false, closeDoor: false, pressOpensDialog: true, sheet: false, siteFoot: false };
  if (presentation === "dialog") return { head: false, hero: false, cartChip: false, closeDoor: false, pressOpensDialog: false, sheet: true, siteFoot: false };
  return { head: true, hero: true, cartChip: false, closeDoor: false, pressOpensDialog: false, sheet: false, siteFoot: true };
}
